import styled, { css } from 'styled-components';
import { Card } from '@/ui/Card/Card';
import { Flex } from '@/ui/Flex/Flex';
import { Button } from '@/ui/Button/Button';

export const StyledCardContentsWrapper = styled.div<{
  readonly maxSlidesPerGroup: number;
}>`
  display: grid;
  grid-template-columns: repeat(
    ${({ maxSlidesPerGroup }) => Math.min(maxSlidesPerGroup, 4)},
    1fr
  );
  gap: 36px;
  place-items: center;
  padding: 16px;
`;

export const StyledSlideGroup = styled.div`
  position: relative;
  min-width: 260px;
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
  display: flex;
`;

export const StyledCard = styled(Card)<{ readonly isExpanded: boolean }>`
  overflow: hidden;
  position: relative;
  transition: max-height 1s ease-in-out;
  ${({ isExpanded }) =>
    isExpanded
      ? css`
          max-height: none; /* Use a very large value instead of none */
        `
      : css`
          max-height: 405px;
        `}
`;

export const StyledMenuButton = styled(Button)`
  position: absolute;
  right: 5px;
  top: 14px;
`;

export const StyledMenu = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 46px;
  right: 5px;
  width: 150px;
  background-color: ${({ theme }) => theme.color('#FFFFFF')};
  border: 1px solid ${({ theme }) => theme.color('#F6F6F6')};
  border-radius: 8px;
  z-index: 1;
  box-shadow: -8px 9px 17px -4px rgba(0, 0, 0, 0.14);
`;

export const StyledExpandButtonWrapper = styled.div<{
  readonly isExpanded: boolean;
}>`
  position: absolute;
  pointer-events: none;
  height: 80px;
  padding: 16px;

  bottom: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  button {
    pointer-events: all;
    box-shadow:
      0px 6px 11px rgba(0, 0, 0, 0.15),
      0px 1.34018px 2.45699px rgba(0, 0, 0, 0.0894161),
      0px 0.399006px 0.731511px rgba(0, 0, 0, 0.0605839);
  }

  ${({ isExpanded }) =>
    isExpanded
      ? css``
      : css`
          background: linear-gradient(
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 50%) 40%,
            rgb(255, 255, 255) 100%
          );
        `}
`;

export const StyledInput = styled.input`
  width: 100%;
  margin-bottom: 25px;
  margin-top: 25px;
  border: 2px solid #b2b1ba;
  border-radius: 4px;
  padding: 10px;
`;

export const StyledFooter = styled(Flex)`
  padding: 18px 32px 32px;
`;

export const StyledSaveButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}

  width: 100px;
  align-self: flex-end;
`;
